///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.short_dated_response = abcsetup.short_dated_response || {};
abcsetup.short_dated_response.workflow = abcsetup.short_dated_response.workflow || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////

abcsetup.short_dated_response.workflow = {

    init: function () {

        $('form').on('submit', (e) => {
            abcsetup.blockUI(true);
        })

        // Approve all items
        $('.approve-all').on('click', function(e) {
            $('#'+$(this).data('table')+' input[value="accepted"]').trigger('click');
        });

        // Reject all items if universal reason can be given
        $('.reject-all').on('click', function(e) {
            var reason = prompt("Please provide a reasons for rejection.\nThis will be applied to all items.", "");

            if (reason !== null && reason !== '') {
                $('#'+$(this).data('table')+' input[value="rejected"]').trigger('click');
                $('#'+$(this).data('table')+' .rejected-reason').val(reason);
            }
        });

        // Reject all items - Short Dated Pricing Team
        $('.reject-all-pricing').on('click', function(e) {
            $('#'+$(this).data('table')+' input[value="rejected"]').trigger('click');
        });

        // Counter all items - Short Dated Pricing Team
        $('.counter-all').on('click', function(e) {
            $('#'+$(this).data('table')+' input[value="pricing_countered"]').trigger('click');
        });

        // Offer letter: make the import button disabled until a file was selected
        $('#offer_letter').on('change', function(){
            if ($(this)[0].files.length === 0) {
                $('#offer_letter_import_button').addClass('disabled').prop('disabled', true);
            } else {
                $('#offer_letter_import_button').removeClass('disabled').prop('disabled', false);
            }
        });

        // Validate sgs approve/reject of new items
        $('#opportunity-review-form').on('submit', function(e) {
            var valid = true;
            $('tr[data-item-id]').each(function() {
                var id = $(this).data('item-id');
                var checked_action = $('input[name="item-'+id+'"]:checked');
                var rejected_reason = $('#item-'+id+'-rejected-reason');

                if (checked_action.val() === undefined) {
                    valid = false;
                } else if (checked_action.val() === 'rejected' && rejected_reason.val() === '') {
                    valid = false;
                }
            });

            if (!valid) {
                e.preventDefault();
                abcsetup.alerts.show('Form Validation', 'You must approve or reject all items to proceed');
                return;
            }
        });

        // Items are being imported from an excel document
        $(document).on("click", "#sgs_import_template_button", function () {
            abcsetup.blockUI();
            abcsetup.excel.readFile($("#update_items_import")[0], function(data) {
                var rows = abcsetup.excel.toArray(data, abcsetup.short_dated_opportunity.common.sgs_column_map);

                // Loop through newly created rows to pop item into the UI
                for (var i in rows) {
                    // var validate = abcsetup.short_dated_opportunity.common.validateSGSNewItem(rows[i]);

                    // if (!validate.valid) {
                    //     abcsetup.alerts.show('Import Error', 'Please correct ' + validate.field + ' on line ' + (parseInt(i, 10) + 2));
                    //     return;
                    // }
                }

                for (var i in rows) {
                    var id = rows[i].id;
                    var status = rows[i].status;
                    var decline_reason = rows[i].decline_reason;

                    $('#item-' + id + '-' + status).trigger('click');

                    if (status == 'rejected') {
                        $('#item-' + id + '-rejected-reason').val(decline_reason);
                    }

                }

                abcsetup.unblockUI();
            }, true);

            $("#update_items_import").val('').trigger('change');
        });

        // SD Pricing Team Additional Review - Auto fill buttons based on file import
        $(document).on("click", "#pricing_team_additional_review_import_button", function () {
            abcsetup.blockUI();
            abcsetup.excel.readFile($("#additional_pricing_update_items_import")[0], function(data) {
                var rows = abcsetup.excel.toArray(data, abcsetup.short_dated_opportunity.common.pricing_column_map);

                // Loop through newly created rows to pop item into the UI
                for (var i in rows) {
                    var id = rows[i].id;
                    var status = rows[i].status;
                    var sell_price = rows[i].sell_price;

                    $('#item-' + id + '-' + status).trigger('click');

                    if (status == 'pricing_countered') {
                        $('#item-' + id + '-pricing-counter-price').val(sell_price);
                    }
                }

                abcsetup.unblockUI();
            }, true);

            $("#additional_pricing_update_items_import").val('').trigger('change');
        });

        // Toggle rejection reason(s) editability
        $('#sd-pricing-sgs-review-form input[type="radio"]').on('change', function() {
            var rejected_reason = $('#'+$(this).attr('name')+'-rejected-reason');
            if ($(this).val() === 'rejected') {
                rejected_reason.prop('disabled', false);
                //trigger('focus');
            } else {
                rejected_reason.prop('disabled', true).val('');
            }
        });

        // Toggle SD Pricing Team's counter editability
        $('#sd-pricing-price-team-form input[type="radio"]').on('change', function() {
            var pricing_counter_price = $('#'+$(this).attr('name')+'-pricing-counter-price');
            if ($(this).val() === 'pricing_countered') {
                pricing_counter_price.prop('disabled', false);
            } else {
                pricing_counter_price.prop('disabled', true).val('');
            }
        });

        // Validate sgs review of pricing team's submission
        $('#sd-pricing-sgs-review-form').on('submit', function(e) {
            var valid = true;
            $('tr[data-item-id]').each(function() {
                var id = $(this).data('item-id');
                var item_sgs_buy_price = $('#item-'+id+'-sgs-buy-price');
                var item_sgs_price = $('#item-'+id+'-sgs-price');
                var item_sgs_quantity = $('#item-'+id+'-sgs-quantity');

                if (isNaN(parseFloat(item_sgs_price.val())) || parseFloat(item_sgs_price.val()) <= 0) {
                    item_sgs_price.addClass('invalid');
                    valid = false;
                    console.log('bad', id);
                }

                if (isNaN(parseInt(item_sgs_quantity.val(), 10)) || parseInt(item_sgs_quantity.val(), 10) <= 0) {
                    item_sgs_quantity.addClass('invalid');
                    valid = false;
                    console.log('bad', id);
                }
            });

            if (!valid) {
                e.preventDefault();
                abcsetup.alerts.show('Form Validation', 'Price(s) must valid and greater than 0.00 and quantities must be greater than 0');
                return;
            }
        });

        $('#update_items_import').on('change', function(){
            if ($(this)[0].files.length === 0) {
                $('#pricing_team_import_button').addClass('disabled').prop('disabled', true);
            } else {
                $('#pricing_team_import_button').removeClass('disabled').prop('disabled', false);
            }
        });

        // SD Pricing Team additional review step import
        $('#additional_pricing_update_items_import').on('change', function(){
            if ($(this)[0].files.length === 0) {
                $('#pricing_team_additional_review_import_button').addClass('disabled').prop('disabled', true);
            } else {
                $('#pricing_team_additional_review_import_button').removeClass('disabled').prop('disabled', false);
            }
        });

        // SGS Team pricing review import
        $('#update_items_import').on('change', function(){
            if ($(this)[0].files.length === 0) {
                $('#sgs_priced_items_import_button').addClass('disabled').prop('disabled', true);
            } else {
                $('#sgs_priced_items_import_button').removeClass('disabled').prop('disabled', false);
            }
        });

        // Validate pricing team submission
        $('#sd-pricing-price-team-form').on('submit', function(e) {
            var valid = true;
            var rows = $('#app_data_tables_short_dated_opportunity_workflow_data_table tbody tr');

            $('td.invalid').removeClass('invalid');

            rows.each(function() {
                var buy_price = $(this).children('.buy_price');
                var sell_price = $(this).children('.sell_price');

                //console.log(buy_price.text());

                if (isNaN(parseFloat(buy_price.text())) || parseFloat(buy_price.text()) <= 0) {
                    buy_price.addClass('invalid');
                    valid = false;
                }

                if (isNaN(parseFloat(sell_price.text())) || parseFloat(sell_price.text()) <= 0) {
                    sell_price.addClass('invalid');
                    valid = false;
                }
            });

            if (!valid) {
                e.preventDefault();
                abcsetup.alerts.show('Form Validation', 'Price(s) must valid and greater than 0.00');
                return;
            }
        });

        // Validate pricing team submission
        $('#sd-pricing-vendor-form').on('submit', function(e) {
            //e.preventDefault();
            console.log(document.activeElement.value);
            // for (var i in e.target.elements) {
            //     //console.log(i, e.target.elements[i]);
            // }

            return;
        });

        // Validate pricing team submission
        $('#sd-pricing-sgs-team-form').on('submit', function(e) {

            if (document.activeElement.value === 'reject') {
                console.log('reject');
            }

            //e.preventDefault();
            //return;
        });

        // Rejection button was clicked
        $('#complete-opportunity-form #reject').on('click', function(e) {
            abcsetup.alerts.confirm('Reject Submission', 'Are you sure you want to reject this submission?', function(confirm) {
                if (confirm) {
                    $('#form_action').val('reject');
                    $('#complete-opportunity-form').trigger('submit');
                } else {
                    $('#form_action').val('approve');
                }
            }, 'Reject', 'btn-danger');
        });

        abcsetup.short_dated_response.workflow.offerLetterDisplay();
    },

    fieldsInit: function () {
        //Bind any fields events
    },

    uploadDone(x) {
        //console.log('done', x, abcsetup.uploader.uploadResult);

        if (abcsetup.uploader.uploadResult.hasOwnProperty('file')) {
            $('#offer-letter-final').val(abcsetup.uploader.uploadResult.file);
        }

        abcsetup.short_dated_response.workflow.offerLetterDisplay();

        // if (abcsetup.uploader.uploadResult.type === 'importSuppliers') {
        //     abcsetup.consumer_rfp.common.importSuppliers(abcsetup.uploader.uploadResult.vals);
        // } else if (abcsetup.uploader.uploadResult.type === 'importItems') {
        //     abcsetup.consumer_rfp.common.importItems(abcsetup.uploader.uploadResult.vals, abcsetup.uploader.uploadResult.extras);
        // }
    },

    /**
     * Correct displays for offer letters
     */
    offerLetterDisplay: function() {
        if ($('#offer-letter')[0] && $('#offer-letter-container')[0]) {
            var path = $('#offer-letter').val();
            var fileinfo = abcsetup.short_dated_response.workflow.getFileInfo(path);

            if (fileinfo.file_name.length > 0 && fileinfo.file_ext.length > 0) {
                $('#offer-letter-container h6').text(fileinfo.file_name + '.' + fileinfo.file_ext);
                $('#offer-letter-container .offer-letter-icon').removeClass('fa-file').addClass('fa-file-'+fileinfo.file_ext)
                $('#offer-letter-container .btn.disabled').removeClass('disabled');
                $('#offer-letter-container').addClass('complete');
            }
        }

        if ($('#offer-letter-final')[0] && $('#offer-letter-final-container')[0]) {
            var path = $('#offer-letter-final').val();
            var fileinfo = abcsetup.short_dated_response.workflow.getFileInfo(path);

            if (fileinfo.file_name.length > 0 && fileinfo.file_ext.length > 0) {
                $('#offer-letter-final-container h6').text(fileinfo.file_name + '.' + fileinfo.file_ext);
                $('#offer-letter-final-container .offer-letter-icon').removeClass('fa-file').addClass('fa-file-'+fileinfo.file_ext)
                $('#offer-letter-final-container .btn.disabled').removeClass('disabled');
                $('#offer-letter-final-container').addClass('complete');
            }
        }

        // Disable the approve button while there is no signed final offer letter uploaded
        if ($('#offer-letter-final-container').hasClass('complete')) {
            $('#sgs-approve-button').prop('disabled', false);
            $('#sgs-approve-button').prop('title', 'Click to approve submission');
        } else {
            $('#sgs-approve-button').prop('disabled', true);
            $('#sgs-approve-button').prop('title', 'Please upload a signed final offer letter first!');
        }
    },

    /**
     * File info for offer letters
     */
    getFileInfo: function(path) {

        var file_name = '';
        var file_ext = '';
        var path_arr = path.split('/');
        var file = path_arr[path_arr.length-1];
        var file_name_arr = file.split('.');

        if (file_name_arr[0]) {
            file_name = file_name_arr[0];

            if (file_name.length > 10) {
                file_name = file_name.substring(0, 5) + '...' + file_name.substring(file_name.length - 6);
            }
        }

        if (file_name_arr[1]) {
            file_ext = file_name_arr[1]
        }

        return {
            file_name: file_name,
            file_ext: file_ext,
        }
    }
}
